import React from 'react';

import { Box } from '@mui/material';

import { spaces } from '../../../../../assets/styles/themes/tokens';
import { colors } from '../../../../../assets/styles/themes/variables';
import createNonPropagatingEventHandler from '../../../../../utils/createNonPropagatingEventHandler';
import FeatureStatusChip from '../FeatureStatusChip';
import { MuiCardBaseProps } from '../MuiCardBase';
import useCardDimensions from '../../../../../utils/useCardDimensions';

export const MuiCardBaseLongWrapper: React.FC<{
  children: React.ReactNode;
  contentType: MuiCardBaseProps['contentType'];
  itemLink: string;
  isNew: boolean;
  isExpanded: boolean;
  openInNewTab?: boolean;
  newTabHref?: string;
}> = ({ children, contentType, itemLink, isNew, isExpanded, openInNewTab, newTabHref }) => {
  const cardDimensions = useCardDimensions();
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && document.activeElement === event.currentTarget) {
      if (openInNewTab) {
        window.open(newTabHref || itemLink, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = itemLink;
      }
    }
  };

  return (
    <Box
      tabIndex={0}
      sx={(theme) => ({
        display: 'flex',
        gap: spaces.md,
        height: isExpanded ? 'unset' : cardDimensions.long.height,
        marginX: 'auto',
        alignItems: 'flex-start',
        [theme.breakpoints.between('mobile', 'tablet')]: {
          maxWidth: cardDimensions.tablet.maxWidth,
        },
        [theme.breakpoints.up('tablet')]: {
          maxWidth: cardDimensions.desktop.maxWidth,
        },
        position: 'relative',
        ':focus': {
          borderRadius: spaces.sm,
          outline: `1px solid ${colors.blue700}`,
        },
      })}
      data-testid={`${contentType}-mui-card`}
      onKeyDown={onKeyDown}
      onMouseDown={createNonPropagatingEventHandler(() => {})}
    >
      {isNew && <FeatureStatusChip size='medium' />}
      {children}
    </Box>
  );
};

export default MuiCardBaseLongWrapper;
